var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title: _vm.id === null ? "Cadastrar Colaborador" : "Editar Colaborador"
      }
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _vm.employee !== null && _vm.employee.natural_entity !== null
                ? _c("NaturalEntity", {
                    key: _vm.id,
                    attrs: {
                      services: _vm.services,
                      naturalEntity: _vm.employee
                        ? _vm.employee.natural_entity
                        : null,
                      isEmployee: true,
                      employee: _vm.employee
                    }
                  })
                : _c("NaturalEntity", {
                    attrs: { isEmployee: true, services: _vm.services }
                  })
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: { label: "Jornada Trabalho", disabled: _vm.isTabEnabled }
            },
            [_c("WorkingTime", { attrs: { services: _vm.services } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }